"use client"

import { useLocale } from "use-intl"
import { createFormatters, type Formatters } from "../formatters"

/**
 * Date and time formatters bound to the language the app is showing, so a component never names or
 * receives a locale. Works in every app: next-intl's provider is use-intl's. Money stays
 * `formatAmount` (Swedish format in every language).
 */
export function useFormatters(): Formatters {
  return createFormatters(useLocale())
}
